define('helpers',['require','component--get-content.es','component--get-content-array.es','component--parse-content.es','component--parse-prop.es','state--get-component.es','state--get-props.es','helperContent-cloneEntity','helperContent-cloneInitEntity','content--get-entity.es','helperContent-getTaskEntities','content--get-quiz-game.es','helperContent-getQuizMap','content--get-training-map.es','helperContent-convertComponents','helperContent-getSectionEntities','helperContent-componentObject','helperContent-customText','entity--is-content-page.es','entity--is-in-page-range.es','entity--is-parent-quiz-task-page.es','entity--is-quiz-game-page.es','entity--is-quiz-page.es','entity--is-quiz-task-page.es','entity--is-task-in-score.es','entity--is-task-page.es','helperLayout','misc--clone-object.es','misc--ms-to-cmi.es','misc--cs-to-iso.es','helperMisc-replaceTextholder','helperNavigation','url--get-param.es','url--parse-modified.es','helperUser'],function(require) {
    'use strict';

    var Helpers = {
        component: {
            getContent: require('component--get-content.es').default,
            getContentArray: require('component--get-content-array.es').default,
            parseContent: require('component--parse-content.es').default,
            parseProp: require('component--parse-prop.es').default
        },
        state: {
            getComponent: require('state--get-component.es').default,
            getProps: require('state--get-props.es').default
        },
        content: {
                    cloneEntity: require('helperContent-cloneEntity'),
                    cloneInitEntity: require('helperContent-cloneInitEntity'),
            getEntity: require('content--get-entity.es').default,
                    getTaskEntities: require('helperContent-getTaskEntities'),  // TODO: remove, not used anywhere
            getQuizGame: require('content--get-quiz-game.es').default,
                    getQuizMap: require('helperContent-getQuizMap'),            // TODO: remove, not used anywhere
            getTrainingMap: require('content--get-training-map.es').default,
                    convertComponents: require('helperContent-convertComponents'),
                    getSectionEntities: require('helperContent-getSectionEntities'),
                    componentObject: require('helperContent-componentObject'),
                    customText: require('helperContent-customText')
        },
        entity: {
            isContentPage: require('entity--is-content-page.es').default,
            isInPageRange: require('entity--is-in-page-range.es').default,
            isParentQuizTaskPage: require('entity--is-parent-quiz-task-page.es').default,
            isQuizGamePage: require('entity--is-quiz-game-page.es').default,
            isQuizPage: require('entity--is-quiz-page.es').default,
            isQuizTaskPage: require('entity--is-quiz-task-page.es').default,
            isTaskInScore: require('entity--is-task-in-score.es').default,
            isTaskPage: require('entity--is-task-page.es').default,
        },

        layout: require('helperLayout'),

        misc: {
            cloneObject: require('misc--clone-object.es').default,              // TODO: remove after ES6 stucture complete & changed in code
            msToCMI: require('misc--ms-to-cmi.es').default,                     // can be moved to SCORM API
            csToISO: require('misc--cs-to-iso.es').default,                     // can be moved to SCORM API
                replaceTextholder: require('helperMisc-replaceTextholder')
        },

        navigation: require('helperNavigation'),

        URL: {
            getParam: require('url--get-param.es').default,
            parseModified: require('url--parse-modified.es').default
        },
        User: require('helperUser')                                             // TODO: remove after user module created
    };

    return Helpers;
});


